module.exports = __webpack_public_path__ + "img/check.8368d202.svg";